import React from 'react';
import Card from './Card';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
}))



export default function Category(props) {
    const {items, onClick} = props;
    const classes = useStyles();
    const handleClick = (item) => (e) => {
        if(onClick) return onClick(item, e);
        console.log(item, e);
    }

  return (
    <Grid container className={classes.root} justifyContent="space-evenly" spacing={1}>
        {items.map((item, i) => (
            <Grid key={i} item xs={12} sm={6} md={4} lg={3} xl={2}>
                <Card label={item.name} description={item.description} img={item.pic_path} onClick={handleClick(item)} />
            </Grid>
        ))}
    </Grid>

  );
}
